import {
  Button,
  Form,
  FormItem,
  Input,
  Modal,
  SubmitButton,
} from '../../../../../components';
import { validateDomains } from '../../../../../components/AgentForm/utils/validators';

export const DEFAULT_CHUNK_SIZE = 2500;
export const DEFAULT_CHUNK_OVERLAP = 250;

export type ExtendByUrlForm = {
  url: string;
};

type ExtendByUrlModalProps = {
  open: boolean;
  onClose: () => void;
  formKey: string;
  urlForm: ExtendByUrlForm;
  onFormChange: (values: ExtendByUrlForm) => void;
  onExtend: () => void;
  extending: boolean;
};

export const ExtendByUrlModal = ({
  open,
  onClose,
  formKey,
  urlForm,
  onFormChange,
  onExtend,
  extending,
}: ExtendByUrlModalProps) => {
  return (
    <Modal
      size="small"
      open={open}
      onClose={onClose}
      title="Add content by URL"
    >
      <div className="flex flex-col gap-y-12 w-full">
        <Form onChange={onFormChange} initialValue={urlForm} key={formKey}>
          <FormItem<ExtendByUrlForm>
            name="url"
            label="URL"
            inline={false}
            required
            validate={validateDomains(['http', 'https'])}
          >
            <Input placeholder="https://example.com" />
          </FormItem>
          <div className="flex flex-col gap-y-md justify-center items-center">
            <SubmitButton
              size="medium"
              disabled={extending}
              className="w-full"
              label="Extend"
              onClick={onExtend}
            />
            <Button
              size="medium"
              type="contrast"
              label="Cancel"
              className="w-full text-main"
              onClick={onClose}
            />
          </div>
        </Form>
      </div>
    </Modal>
  );
};
